export default __webpack_public_path__ + "static/Entenda0107-b5f2d2e41d608498fbfed212d7d6363b.jpg";